import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { BrowserService } from 'src/_lib/service/browser.service';

@Injectable({
  providedIn: 'root'
})
export class TopSellersService {
  endpoint: string = environment.apiUrl;
  topSellersCache$?: Observable<any> | null = null;
  featuredProductsCache$?: Observable<any> | null = null;
  topSellingCategoriesCache$?: Observable<any> | null = null;

  constructor(private browser: BrowserService, private http: HttpClient) { }

  topSellersData(flag:string): Observable<any> {
    if (this.topSellersCache$) {
      return this.topSellersCache$;
    }
    const storedData = this.getFromLocalStorage();
    if (storedData) {
      this.topSellersCache$ = of(storedData).pipe(shareReplay(1));
      return this.topSellersCache$;
    }
    this.topSellersCache$ = this.http.post(this.endpoint + 'featured-products',{flag:flag}).pipe(shareReplay(1));
    this.topSellersCache$.subscribe(data => {
      this.saveToLocalStorage(data);
    });
    return this.topSellersCache$;
  }

  featuredProducts(flag:string): Observable<any> {
    if (this.featuredProductsCache$) {
      return this.featuredProductsCache$;
    }
    const storedData = this.getFromLocalStoragefeaturedProduct();
    if (storedData) {
      this.featuredProductsCache$ = of(storedData).pipe(shareReplay(1));
      return this.featuredProductsCache$;
    }
    this.featuredProductsCache$ = this.http.post(this.endpoint + 'featured-products',{flag:flag}).pipe(shareReplay(1));
    this.featuredProductsCache$.subscribe(data => {
      this.saveToLocalStoragefeaturedProduct(data);
    });
    return this.featuredProductsCache$;
  }

  topSellingCategories(): Observable<any> {
     if (this.topSellingCategoriesCache$) {
      return this.topSellingCategoriesCache$;
    }
    const storedData = this.getCategoriesFromLocalStorage();
    if (storedData) {
      this.topSellingCategoriesCache$ = of(storedData).pipe(shareReplay(1));
      return this.topSellingCategoriesCache$;
    }
    this.topSellingCategoriesCache$ = this.http.get(this.endpoint + 'top-trending-categories').pipe(shareReplay(1));
    this.topSellingCategoriesCache$.subscribe(data => {
      this.saveCategoriesToLocalStorage(data);
    });
    return this.topSellingCategoriesCache$;
  }

  saveToLocalStorage(data: any): void {
    this.browser.localStorage?.setItem('topSellerData', JSON.stringify(data));
  }

  saveToLocalStoragefeaturedProduct(data: any): void {
    this.browser.localStorage?.setItem('featureProductData', JSON.stringify(data));
  }

  saveCategoriesToLocalStorage(data: any): void {
    this.browser.localStorage?.setItem('topSellingCategoriesData', JSON.stringify(data));
  }

  getCategoriesFromLocalStorage(): any | null {
    const data = this.browser.localStorage?.getItem('topSellingCategoriesData');
    return data ? JSON.parse(data) : null;
  }

  getFromLocalStorage(): any | null {
    const data = this.browser.localStorage?.getItem('topSellerData');
    return data ? JSON.parse(data) : null;
  }

  getFromLocalStoragefeaturedProduct(): any | null {
    const data = this.browser.localStorage?.getItem('featureProductData');
    return data ? JSON.parse(data) : null;
  }
}